import { useState } from 'react';

export const usePlaybooksPaging = (totalCount: number = 0) => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const totalPages = Math.ceil(totalCount / limit);

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleItemsPerPageChange = (newLimit: number) => {
        setLimit(newLimit);
        setPage(1); // Reset to first page
    };

    return {
        page,
        limit,
        totalPages,
        totalCount,
        handlePageChange,
        handleItemsPerPageChange,
    };
};
